import _ from 'lodash'
import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../../../redux/loading'

import { ImportSearchActions } from './actions'
import { ImportSearchState } from './types'

export const initialState: ImportSearchState = {
  data: { items: [], isItemWithMoreResults: false, isItemWithNoResults: false, allEnabled: false },
  page: 1,
  totalPages: 1
}

export const reducer: Reducer<ImportSearchState, ImportSearchActions> = (
  state = initialState,
  action
): ImportSearchState => {
  switch (action.type) {
    case getType(ImportSearchActions.fetchData): {
      return {
        ...state,
        data:
          action.payload.importId && state.importId && action.payload.importId !== state.importId
            ? initialState.data
            : state.data,
        importId: action.payload.importId ?? state.importId,
        page: action.payload.page
      }
    }
    case getType(ImportSearchActions.setData): {
      return {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        totalPages: action.payload.totalPages
      }
    }
    case getType(ImportSearchActions.setEnabled): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i => ({
            ...i,
            enabled: action.payload.itemId === i.id ? action.payload.enabled : i.enabled
          })),
          allEnabled: !action.payload.enabled ? false : state.data.allEnabled
        }
      }
    }
    case getType(ImportSearchActions.setAllEnabled): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i => ({
            ...i,
            enabled:
              action.payload.enabled &&
              (!i.notFound || i.investigationAvailable) &&
              (_.size(i.moreSearchResults) === 0 || _.some(i.moreSearchResults || [], sr => sr.selected))
          })),
          allEnabled: action.payload.enabled
        }
      }
    }
    case getType(ImportSearchActions.setSearchResultEnabled): {
      return {
        ...state,
        data: {
          ...state.data,
          items: _.map(state.data.items, i => ({
            ...i,
            moreSearchResults:
              action.payload.itemId === i.id && _.size(i.moreSearchResults) > 0
                ? _.map(i.moreSearchResults, sr => ({
                    ...sr,
                    selected: action.payload.companyIdentifier === sr.companyIdentifier
                  }))
                : i.moreSearchResults
          }))
        }
      }
    }
    default:
      return state
  }
}

export const importSearchReducer = withLoadingReducer(reducer, 'importSearch', initialState)
